import { TabValue } from 'features/cost-report/components/CostReportTabs';

import { CostReportTab } from '../../../cost-report/types/common';

export const workloadsTabs: Partial<Record<CostReportTab, TabValue>> = {
  [CostReportTab.COMPUTE_COST]: {
    label: 'Compute cost',
    reportType: 'computeCost',
  },
  [CostReportTab.RELIABILITY]: {
    label: 'Reliability',
    reportType: 'reliability',
  },
  [CostReportTab.NETWORK_COST]: {
    label: 'Network cost',
    reportType: 'networkCost',
  },
  [CostReportTab.EFFICIENCY]: { label: 'Efficiency', reportType: 'efficiency' },
  [CostReportTab.GPU_UTILIZATION]: {
    label: 'GPU utilization',
    reportType: 'gpuUtilization',
  },
  [CostReportTab.TOTAL_COST]: { label: 'Total cost' },
};
